import { ISimplifiedNode } from '../../components/ingestion/IngestedTree'
import { getLessonNum } from './utility'
import { createNoteNode } from '../nodeCreationHelpers'
import { boldTitleSpan } from './html'
import { processMaterialElement } from './studentGuideMaterial'
import { IUnitLessonParams } from './types'

export function parseStudentGuides(params: IUnitLessonParams) {
  const materialGroups = materialsByLanguage(params)
  return Object.values(materialGroups).reduce<ISimplifiedNode[]>(
    (acc, elements) => {
      return [
        ...acc,
        ...studentGuideForMaterialElements({
          elements,
          params,
        }),
      ]
    },
    [],
  )
}

function studentGuideForMaterialElements({
  elements,
  params,
}: {
  elements: Element[]
  params: IUnitLessonParams
}) {
  return [
    createNoteNode({
      title: `Lesson ${getLessonNum(params.metadata)}`,
      value: boldTitleSpan(params.metadata.name),
      studentFacing: true,
    }),
    ...elements.reduce<ISimplifiedNode[]>((acc, elem) => {
      return [...acc, ...processMaterialElement(elem, params)]
    }, []),
  ]
}

function materialsByLanguage(params: IUnitLessonParams) {
  const {
    lessonElement,
    metadata: { material },
  } = params
  return material.reduce<Record<string, Element[]>>((acc, m) => {
    const elem = lessonElement.querySelector(m['@id'])
    if (!elem) return acc
    const lang = m.inLanguage.name
    if (!(lang in acc)) {
      acc[lang] = []
    }
    acc[lang].push(elem)
    return acc
  }, {})
}
